import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import axios from 'axios';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
import './data-extraction-poll.component.scss';
var DataExtractionPoll = /** @class */ (function (_super) {
    tslib_1.__extends(DataExtractionPoll, _super);
    function DataExtractionPoll(element) {
        return _super.call(this, element) || this;
    }
    DataExtractionPoll.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.valueType = 'poll';
        this.buttonSubmit = this.element.querySelector('.js-submit-button');
        this.selectType = Array.from(this.element.querySelectorAll('.js-radio-topic'));
        this.selectSiteName = this.element.querySelector('.js-site-name');
        this.selectPollName = this.element.querySelector('.js-poll-name');
        this.inputDateStart = this.element.querySelector('input.js-start-date');
        this.inputDateEnd = this.element.querySelector('input.js-end-date');
        // this.selectListType = this.element.querySelector('.js-list-type');
        this.containerPollName = this.element.querySelector('.js-poll-name-group');
        this.containerListType = this.element.querySelector('.js-list-type-group');
        this.containerLoader = this.element.querySelector('.form__loader--container');
        this.containerFields = this.element.querySelector('.form__fields--container');
        this.containerResults = this.element.querySelector('.data-extraction-poll__results');
        this.containerNoresults = this.element.querySelector('.data-extraction-poll__noresults');
        this.containerTable = this.element.querySelector('.data-extraction-poll__results__table');
        this.inputUsername = this.element.querySelector('.js-username');
        this.inputPassword = this.element.querySelector('.js-password');
        // DATE PICKER
        var validateForm = this.form;
        var validateService = this.validationService;
        var validateOnchangeJquery = this.validateOnchangeJquery;
        var validateButton = this.buttonSubmit;
        $(document).ready(function () {
            // start dateppicker
            $('input.js-start-date').datepicker({
                format: "yyyy/mm/dd",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            }).on('changeDate', function (event) {
                var element = event.target;
                var date = new Date(element.value);
                var formattedDate = date.setDate(date.getDate() + 1);
                var dateNew = new Date(formattedDate);
                var dateYear = dateNew.getFullYear();
                var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
                var dateDay = dateNew.getDate().toString().padStart(2, "0");
                var dateFormatted = dateYear + '/' + dateMonth + '/' + dateDay;
                $('input.js-end-date').datepicker('setStartDate', dateFormatted);
                validateOnchangeJquery(validateForm, validateService, validateButton);
            });
            // end datepicker
            $('input.js-end-date').datepicker({
                format: "yyyy/mm/dd",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            }).on('changeDate', function (event) {
                var element = event.target;
                var date = new Date(element.value);
                var formattedDate = date.setDate(date.getDate() - 1);
                var dateNew = new Date(formattedDate);
                var dateYear = dateNew.getFullYear();
                var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
                var dateDay = dateNew.getDate().toString().padStart(2, "0");
                var dateFormatted = dateYear + '/' + dateMonth + '/' + dateDay;
                $('input.js-start-date').datepicker('setEndDate', dateFormatted);
                validateOnchangeJquery(validateForm, validateService, validateButton);
            });
        });
    };
    DataExtractionPoll.prototype.bindEvents = function () {
        var _this = this;
        this.selectType.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            _this.valueType = element.value;
            _this.selection(element.value);
            _this.validateOnchange();
        }); });
        // this.inputDateStart.addEventListener('change', (event)=>{
        // 	let element: any = event.target;
        // 	let date: any = new Date(element.value);
        // 	let formattedDate: any = date.setDate(date.getDate() + 1);
        //     let dateNew: any = new Date(formattedDate);
        // 	let dateYear: any = dateNew.getFullYear();
        // 	let dateMonth: any = (dateNew.getMonth() + 1).toString().padStart(2, "0");
        // 	let dateDay: any = dateNew.getDate().toString().padStart(2, "0");
        // 	let dateFormatted: any = dateYear+'-'+dateMonth+'-'+dateDay;
        // 	this.inputDateEnd.setAttribute('min', dateFormatted);
        // 	this.validateOnchange();
        // })
        // this.inputDateStart.addEventListener('keyup', (event)=>{
        // 	let element: any = event.target;
        // 	let date_regex: any = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        // 	if ((date_regex.test(element.value))) {
        // 		let date: any = new Date(element.value);
        // 		let formattedDate: any = date.setDate(date.getDate() + 1);
        // 		let dateNew: any = new Date(formattedDate);
        // 		let dateYear: any = dateNew.getFullYear();
        // 		let dateMonth: any = (dateNew.getMonth() + 1).toString().padStart(2, "0");
        // 		let dateDay: any = dateNew.getDate().toString().padStart(2, "0");
        // 		let dateFormatted: any = dateYear+'-'+dateMonth+'-'+dateDay;
        // 		this.inputDateEnd.setAttribute('min', dateFormatted);
        // 	}
        // 	this.validateOnchange();
        // })
        // this.inputDateEnd.addEventListener('change', (event)=>{
        // 	let element: any = event.target;
        // 	let date: any = new Date(element.value);
        // 	let formattedDate: any = date.setDate(date.getDate() - 1);
        //     let dateNew: any = new Date(formattedDate);
        // 	let dateYear: any = dateNew.getFullYear();
        // 	let dateMonth: any = (dateNew.getMonth() + 1).toString().padStart(2, "0");
        // 	let dateDay: any = dateNew.getDate().toString().padStart(2, "0");
        // 	let dateFormatted: any = dateYear+'-'+dateMonth+'-'+dateDay;
        // 	this.inputDateStart.setAttribute('max', dateFormatted);
        // 	this.validateOnchange();
        // })
        // this.inputDateEnd.addEventListener('keyup', (event)=>{
        // 	let element: any = event.target;
        // 	let date_regex: any = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        // 	if ((date_regex.test(element.value))) {
        // 		let date: any = new Date(element.value);
        // 		let formattedDate: any = date.setDate(date.getDate() - 1);
        // 		let dateNew: any = new Date(formattedDate);
        // 		let dateYear: any = dateNew.getFullYear();
        // 		let dateMonth: any = (dateNew.getMonth() + 1).toString().padStart(2, "0");
        // 		let dateDay: any = dateNew.getDate().toString().padStart(2, "0");
        // 		let dateFormatted: any = dateYear+'-'+dateMonth+'-'+dateDay;
        // 		this.inputDateStart.setAttribute('max', dateFormatted);
        // 	}
        // 	this.validateOnchange();
        // })
        this.selectSiteName.addEventListener('change', function (event) {
            _this.validateOnchange();
        });
        this.selectPollName.addEventListener('change', function (event) {
            _this.validateOnchange();
        });
        this.buttonSubmit.addEventListener('click', function (event) {
            _this.validate();
        });
    };
    DataExtractionPoll.prototype.selection = function (value) {
        if (value === 'poll') {
            this.selectPollName.classList.add('form__input--required');
            this.containerPollName.classList.remove('d-none');
        }
        else {
            this.containerPollName.classList.add('d-none');
            this.selectPollName.classList.remove('form__input--required');
        }
    };
    DataExtractionPoll.prototype.validate = function () {
        var formFields = this.form.querySelectorAll('input, select, textarea');
        var validation = this.validationService.validateEnterprise(formFields);
        if (validation.valid) {
            this.action();
        }
    };
    DataExtractionPoll.prototype.validateOnchange = function () {
        var formFields = this.form.querySelectorAll('input, select, textarea');
        var validation = this.validationService.validateEnterprise(formFields);
        if (validation.valid) {
            this.buttonSubmit.classList.remove('button--disabled');
        }
        else {
            this.buttonSubmit.classList.add('button--disabled');
        }
    };
    DataExtractionPoll.prototype.validateOnchangeJquery = function (form, service, button) {
        var formFields = form.querySelectorAll('input, select, textarea');
        var validation = service.validateEnterprise(formFields);
        if (validation.valid) {
            button.classList.remove('button--disabled');
        }
        else {
            button.classList.add('button--disabled');
        }
    };
    DataExtractionPoll.prototype.action = function () {
        this.containerFields.classList.add('d-none');
        this.containerResults.classList.add('d-none');
        this.containerNoresults.classList.add('d-none');
        this.containerLoader.classList.add('d-block');
        if (this.valueType === 'poll') {
            this.actionpoll();
        }
        else {
            this.actionnewsletter();
        }
    };
    DataExtractionPoll.prototype.actionpoll = function () {
        var containerFields = this.containerFields;
        var containerLoader = this.containerLoader;
        var containerResults = this.containerResults;
        var containerNoresults = this.containerNoresults;
        var containerTable = this.containerTable;
        containerTable.innerHTML = '';
        var postData = '';
        if (this.selectSiteName) {
            postData += 'sitename=' + this.selectSiteName.value + '&';
        }
        if (this.selectPollName) {
            postData += 'pollname=' + this.selectPollName.value + '&';
        }
        if (this.inputDateStart) {
            postData += 'startdate=' + this.inputDateStart.value + '&';
        }
        if (this.inputDateEnd) {
            postData += 'enddate=' + this.inputDateEnd.value + '&';
        }
        // variables
        var url = "http://sb.imgraham.co.za/api/form";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // create data
            var data = [{
                    poll_name: 'Poll XYZ',
                    question: 'Do you find the Standard Bank website e…',
                    answer: 'yes',
                    site_name: 'South Africa',
                    client_id: '1700QRxg789778sxzh89',
                    poll_display: 'Poll Display',
                },
                {
                    poll_name: 'Poll XYZ',
                    question: 'Do you find the Standard Bank website e…',
                    answer: 'yes',
                    site_name: 'South Africa',
                    client_id: '1700QRxg789778sxzh89',
                    poll_display: 'Poll Display',
                },
                {
                    poll_name: 'Poll XYZ',
                    question: 'Do you find the Standard Bank website e…',
                    answer: 'yes',
                    site_name: 'South Africa',
                    client_id: '1700QRxg789778sxzh89',
                    poll_display: 'Poll Display',
                },
                {
                    poll_name: 'Poll XYZ',
                    question: 'Do you find the Standard Bank website e…',
                    answer: 'yes',
                    site_name: 'South Africa',
                    client_id: '1700QRxg789778sxzh89',
                    poll_display: 'Poll Display',
                },
                {
                    poll_name: 'Poll XYZ',
                    question: 'Do you find the Standard Bank website e…',
                    answer: 'yes',
                    site_name: 'South Africa',
                    client_id: '1700QRxg789778sxzh89',
                    poll_display: 'Poll Display',
                },
                {
                    poll_name: 'Poll XYZ',
                    question: 'Do you find the Standard Bank website e…',
                    answer: 'yes',
                    site_name: 'South Africa',
                    client_id: '1700QRxg789778sxzh89',
                    poll_display: 'Poll Display',
                }
            ];
            // create table
            var table = "<table class=\"table\"><thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>NAME</th>\n\t\t\t\t\t<th>QUESTION</th>\n\t\t\t\t\t<th>ANSWER</th>\n\t\t\t\t\t<th>SITENAME</th>\n\t\t\t\t\t<th>CLIENT_ID</th>\n\t\t\t\t\t<th>POLL DISPLAY</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            data.forEach(function (item) {
                table += "<tr style=\"cursor:pointer\" onclick=\"location.href='#';\">\n\t\t\t\t\t<td>" + item.poll_name + "</td>\n\t\t\t\t\t<td>" + item.question + "</td>\n\t\t\t\t\t<td>" + item.answer + "</td>\n\t\t\t\t\t<td>" + item.site_name + "</td>\n\t\t\t\t\t<td>" + item.client_id + "</td>\n\t\t\t\t\t<td>" + item.poll_display + "</td>\n\t\t\t\t</tr>";
            });
            table += "</tbody></table>";
            // innerhtmml and show containers
            containerTable.innerHTML = table;
            containerLoader.classList.remove('d-block');
            containerResults.classList.remove('d-none');
            containerFields.classList.remove('d-none');
        }).catch(function (response) {
            // service failed
        });
    };
    DataExtractionPoll.prototype.actionnewsletter = function () {
        var containerFields = this.containerFields;
        var containerLoader = this.containerLoader;
        var containerResults = this.containerResults;
        var containerNoresults = this.containerNoresults;
        var containerTable = this.containerTable;
        containerTable.innerHTML = '';
        var postData = '';
        if (this.selectSiteName) {
            postData += 'sitename=' + this.selectSiteName.value + '&';
        }
        if (this.inputDateStart) {
            postData += 'startdate=' + this.inputDateStart.value + '&';
        }
        if (this.inputDateEnd) {
            postData += 'enddate=' + this.inputDateEnd.value + '&';
        }
        // if (this.selectListType) {
        // 	postData += 'listtype=' + this.selectListType.value + '&';
        // }		
        // variables
        var url = "http://sb.imgraham.co.za/api/form";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            containerLoader.classList.remove('d-block');
            // create data
            var data = [{
                    news_date: '23 Nov 2020, 11:30 PM',
                    first_name: 'Bradley',
                    last_name: 'Gardner',
                    email: 'bradley.j@gmail.com',
                    topics: 'African countries, Finance',
                    site_name: 'South Africa',
                },
                {
                    news_date: '23 Nov 2020, 11:30 PM',
                    first_name: 'Bradley',
                    last_name: 'Gardner',
                    email: 'bradley.j@gmail.com',
                    topics: 'African countries, Finance',
                    site_name: 'South Africa',
                },
                {
                    news_date: '23 Nov 2020, 11:30 PM',
                    first_name: 'Bradley',
                    last_name: 'Gardner',
                    email: 'bradley.j@gmail.com',
                    topics: 'African countries, Finance',
                    site_name: 'South Africa',
                },
                {
                    news_date: '23 Nov 2020, 11:30 PM',
                    first_name: 'Claire',
                    last_name: 'Gardner',
                    email: 'bradley.j@gmail.com',
                    topics: 'African countries, Finance',
                    site_name: 'South Africa',
                },
                {
                    news_date: '23 Nov 2020, 11:30 PM',
                    first_name: 'Claire',
                    last_name: 'Scott',
                    email: 'bradley.j@gmail.com',
                    topics: 'African countries, Finance',
                    site_name: 'South Africa',
                },
                {
                    news_date: '23 Nov 2020, 11:30 PM',
                    first_name: 'Claire',
                    last_name: 'Scott',
                    email: 'bradley.j@gmail.com',
                    topics: 'African countries, Finance',
                    site_name: 'South Africa',
                }
            ];
            // create table
            var table = "<table class=\"table\"><thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>DATE</th>\n\t\t\t\t\t<th>FIRST NAME</th>\n\t\t\t\t\t<th>LAST NAME</th>\n\t\t\t\t\t<th>EMAIL</th>\n\t\t\t\t\t<th>TOPICS</th>\n\t\t\t\t\t<th>SITENAME</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>";
            data.forEach(function (item) {
                table += "<tr style=\"cursor:pointer\" onclick=\"location.href='#';\">\n\t\t\t\t\t<td>" + item.news_date + "</td>\n\t\t\t\t\t<td>" + item.first_name + "</td>\n\t\t\t\t\t<td>" + item.last_name + "</td>\n\t\t\t\t\t<td>" + item.email + "</td>\n\t\t\t\t\t<td>" + item.topics + "</td>\n\t\t\t\t\t<td>" + item.site_name + "</td>\n\t\t\t\t</tr>";
            });
            table += "</tbody></table>";
            // innerhtmml and show containers
            containerTable.innerHTML = table;
            containerLoader.classList.remove('d-block');
            containerResults.classList.remove('d-none');
            containerFields.classList.remove('d-none');
        }).catch(function (response) {
            // service failed
        });
    };
    return DataExtractionPoll;
}(Base));
export { DataExtractionPoll };



//////////////////
// WEBPACK FOOTER
// ./components/data-extraction-poll/data-extraction-poll.component.ts
// module id = 577
// module chunks = 0